document.addEventListener('DOMContentLoaded', () => {
  const widthInput = document.getElementById('calcWidth');
  const heightInput = document.getElementById('calcHeight');
  const kitPreview = document.getElementById('kitPreview');
  const kitWTitle = document.getElementById('kitWTitle');
  const kitHTitle = document.getElementById('kitHTitle');
  const kitCompTitle = document.getElementById('kitCompTitle');
  const kitSelectbtn = document.getElementById('slot-select');
  const continue1btn = document.getElementById('calcContinue1');
  const continue2btn = document.getElementById('calcContinue2');
  const whatsappbtn = document.getElementById('btnWhatsapp');
  const loadingEl = document.getElementById('calcLoading');
  
  const { kits } = kitjson();
  var payload = {};
  var kitcategory = null;
  var range_composition = null;

  var model_selections = {};

  // Composition constant, width-chip
  var composition_array = [];
  var selected_width_chip = [];

  // Drag variable
  const width_track = document.querySelector(".model-width-track");
  const width_tray  = document.getElementById("modelWidthTray");
  let dragEl = null;
  let startX = 0;
  let startY = 0;
  let dx = 0;
  let minDx = 0;
  let maxDx = 0;
  let dropTarget = null;

  // Live Change Variable Section 2
  last_section_active = false;

  // Whatsapp Send Controls
  const COOLDOWN_MS = 10_000;
  const LAST_KEY = "wa_last_send_ts";

// Event Listeners

  // Proceed action for Section 1 (Measurement)
  continue1btn.addEventListener('click', handleProceedSection1)

  // Proceed action for Section 2 (Model Type)
  continue2btn.addEventListener('click', handleProceedSection2)

  whatsappbtn.addEventListener('click', async () => {
    try {
      const last = Number(localStorage.getItem(LAST_KEY) || 0);
      const now = Date.now();
      if (now - last < COOLDOWN_MS) {
        alert(`Please wait ${Math.ceil((COOLDOWN_MS - (now - last))/1000)}s before sending again.`);
        return;
      }
      localStorage.setItem(LAST_KEY, String(now));

      if (whatsappbtn.dataset.sending === '1') return;
      whatsappbtn.dataset.sending = '1';
      whatsappbtn.disabled = true;
      showLoading();

      payload.websiteb = document.querySelector('#websiteb').value;
      payload.deviceId = getDeviceId();

      const { id, key } = await window.writeEnquiries(payload);

      const summaryUrl =
        `${location.origin}/pages/customization-calculator-summary?id=${encodeURIComponent(id)}&key=${encodeURIComponent(key)}`;

      const businessPhone = '60146622867';

      const name  = payload.name || '';
      const phone = payload.phonenum || '';
      const city  = payload.city || '';
      const state = payload.state || '';

      const msg = encodeURIComponent(
  `Hi, I would like to ask more about this customized wardrobe:
  ${summaryUrl}

  Name: ${name}
  Phone No: +60${phone}
  From: ${city}${city && state ? ', ' : ''}${state}`
      );

      const waMeUrl = `https://wa.me/${businessPhone}?text=${msg}`;
      const waSchemeUrl = `whatsapp://send?phone=${businessPhone}&text=${msg}`;

      const isMobile = /Android|iPhone|iPad|iPod/i.test(navigator.userAgent);

      if (isMobile) {
        window.location.href = waSchemeUrl;
        setTimeout(() => { window.location.href = waMeUrl; }, 700);
      } else {
        window.location.href = waMeUrl;
      }

    } catch (err) {
      alert('Failed to send. Please try again.');
      console.error(err);
    } finally {
      whatsappbtn.dataset.sending = '0';
      whatsappbtn.disabled = false;
      hideLoading();
    }
  });

  kitSelectbtn.addEventListener('change', (e) => {
    document.querySelectorAll('#calcModelType li.calc-preview-model.slot-active').forEach(element => {
      element.classList.remove('slot-active');
    })
    document.querySelectorAll('.calc-model-select-grid li.calc-select-model.slot-active').forEach(element => {
      element.classList.remove('slot-active');
    })
    document.querySelector(`#calcModelType li.calc-preview-model[data-model-slot="${e.target.value}"]`).classList.add('slot-active');
  })

  document.querySelectorAll('#kitPreview li.calc-preview-model').forEach(element => {    
    element.addEventListener('click', (e) => {
      document.querySelectorAll('#calcModelType li.calc-preview-model.slot-active').forEach(e2 => {
        e2.classList.remove('slot-active');
      })
      document.querySelectorAll('.calc-model-select-grid li.calc-select-model.slot-active').forEach(element => {
        element.classList.remove('slot-active');
      })

      kitSelectbtn.value = element.dataset.modelSlot;
      element.classList.add('slot-active');
    });
  });

  document.querySelectorAll('#modelSelection li.calc-select-model').forEach(element => {
    element.addEventListener('click', (e) => {
      document.querySelectorAll('#modelSelection li.calc-select-model.slot-active').forEach(e2 => {
        e2.classList.remove('slot-active');
      })
      element.classList.add('slot-active');

      var selected_slot = convertNum(kitSelectbtn.value);
      var slot = document.querySelector("li#calcModelSlot" + selected_slot);
      var imgElem = slot.querySelector('img');
      var nameElem = slot.querySelector('.model_name');
      var priceElem = slot.querySelector('.model_price');
      var model_width = slot.querySelector('.model-width-preview').dataset.slotWidth;
      
      if (element.dataset.modelPriceVariation != '[]') {
        var priceVariation = JSON.parse(element.dataset.modelPriceVariation);
        const priceByWidth = Object.fromEntries(priceVariation.map(v => [Number(v.width), Number(v.price)]));
        var price = priceByWidth[model_width].toFixed(2);
      } else {
        var priceVariation = '[]';
        var price = element.dataset.modelPrice;
      }

      var model = {
        id: element.dataset.modelId,
        name: element.dataset.modelName,
        price: price,
        price_variation: priceVariation,
        description: element.dataset.modelDescription,
        width: model_width,
        img: element.dataset.modelImg,
        secondImg: element.dataset.modelSecondaryImg,
      };

      imgElem.setAttribute('src', model.img);
      nameElem.innerText = model.name;
      priceElem.innerText = 'RM ' + model.price;
      nameElem.classList.remove('visibility-hidden');
      priceElem.classList.remove('visibility-hidden');
      
      setSelection(selected_slot, model);

      slot.dataset.modelId = element.dataset.modelId;
      slot.dataset.modelPrice = element.dataset.modelPrice;
      slot.dataset.modelPriceVariation = element.dataset.modelPriceVariation;

      // Live Change Section 2
      liveChangeSection2();
    });
  })

  document.querySelectorAll('#calcLocation .has-status :is(input, select)[required]').forEach(element => {
    element.addEventListener("change", (event) => {
      const goodicon = element.closest('.has-status').querySelector('.status-ok');
      const badicon = element.closest('.has-status').querySelector('.status-bad');

      if (event.target.value) {
        goodicon.classList.remove('hidden');
        badicon.classList.add('hidden');
      } else {
        badicon.classList.remove('hidden');
        goodicon.classList.add('hidden');
      }
    })
  })

  document.querySelector('#calcLocation .has-status #states').addEventListener("change", (event) => {
    // Live Change Section 2 (only for location input)
    liveChangeSection2();
  })

  // Drag drop width - start drag
  width_tray.addEventListener("pointerdown", (e) => {
    const chip = e.target.closest(".model-width-chip");
    if (!chip) return;

    selected_width_chip.push(chip.dataset.slot);

    dragEl = chip;
    startX = e.clientX;
    startY = e.clientY;
    dx = 0;

    // Clamp range so it stays inside the black container
    const tr = width_track.getBoundingClientRect();
    const cr = chip.getBoundingClientRect();
    minDx = tr.left - cr.left;
    maxDx = tr.right - cr.right;

    chip.setPointerCapture(e.pointerId);
    chip.classList.add("is-dragging");

    e.preventDefault();
  });

  // Drag drop width - moving
  width_tray.addEventListener("pointermove", (e) => {
    if (!dragEl) return;

    dx = e.clientX - startX;
    if (dx < minDx) dx = minDx;
    if (dx > maxDx) dx = maxDx;

    dragEl.style.transform = `translateX(${dx}px)`;

    // Find what we are "over" (for swapping)
    const chips = [...width_tray.querySelectorAll(".model-width-chip")]
      .filter(c => c !== dragEl && !c.classList.contains("hidden") && !c.hasAttribute("hidden"));
    let over = null;

    for (const c of chips) {
      const r = c.getBoundingClientRect();
      if (e.clientX <= r.right) {
        over = c;
        break;
      }
    }
    if (!over && chips.length) over = chips[chips.length - 1];

    if (dropTarget && dropTarget !== over) dropTarget.classList.remove("is-drop-target");

    if (over && over !== dragEl && width_track.contains(over)) {
      dropTarget = over;
      dropTarget.classList.add("is-drop-target");
    } else {
      dropTarget = null;
    }
  });

  width_tray.addEventListener("pointerup", (e) => {
    if (!dragEl) return;

    dragEl.classList.remove("is-dragging");
    dragEl.style.transform = "";

    if (dropTarget) {
      selected_width_chip.push(dropTarget.dataset.slot);
      dropTarget.classList.remove("is-drop-target");

      swapWidthChips(dragEl, dropTarget);
    }
    
    selected_width_chip = [];
    dragEl = null;
    dropTarget = null;

    // Live Change Section 2
    liveChangeSection2();
  });

  width_tray.addEventListener("pointercancel", () => {
    if (!dragEl) return;
    dragEl.classList.remove("is-dragging");
    dragEl.style.transform = "";
    if (dropTarget) {
      dropTarget.classList.remove("is-drop-target");
    }
    selected_width_chip = [];
    dragEl = null;
    dropTarget = null;
  });

  

// Functions

  function handleProceedSection1() {
    var w = widthInput.valueAsNumber;
    var h = heightInput.valueAsNumber;
    const minw = 68; // min 68 cm
    const maxw = 593; // max 593 cm
    const minh = 180; // min 180 cm
    const maxh = 350; // max 350 cm

    var warningMsg = document.getElementById('calcSec1Warning');
    var lockcontent = document.getElementById('calcSecLock2');
    var opencontent = document.getElementById('calcSec2');
    
    if (Number.isNaN(w) || Number.isNaN(h)) {
      warningMsg.classList.remove('hidden');
      return;
    } else if (w < minw || w > maxw) {
      warningMsg.textContent = "Please fill in with valid width, min: 68 cm, max: 593cm";
      warningMsg.classList.remove('hidden');
      return;
    } else if (h < minh || h > maxh) {
      warningMsg.textContent = "Please fill in with valid height, min: 180 cm, max: 350cm";
      warningMsg.classList.remove('hidden');
      return;
    } else {
      warningMsg.classList.add('hidden');
      lockcontent.classList.add('hidden');

      var {kit, range} = calculateKitCategory(w, h);
      
      payload.wall_width = w;
      payload.wall_height = h;
      payload.kitnum = kit.kit_no;
      payload.kitprice = kit.price;
      payload.kitcomposition = range.composition;

      resetSec();
      toggleSec2(kit, range);
      opencontent.classList.remove('hidden');
    }
  }

  function handleProceedSection2() {
    var warningMsgModel = document.getElementById('calcSec2WarningModel');
    var warningMsgLocation = document.getElementById('calcSec2WarningLocation');
    var lockcontent = document.getElementById('calcSecLock3');
    var opencontent = document.getElementById('calcSec3');

    // Check Model Type
    var empty_modeltype = document.querySelectorAll(
      '#calcModelType li.calc-preview-model[data-model-active=true][data-model-id=""]'
    );
    if (empty_modeltype.length != 0) {
      warningMsgModel.classList.remove('hidden');
      warningMsgLocation.classList.add('hidden');
      return;
    }

    // Check Info
    var name = document.querySelector('#calcLocation #custname').value;
    var phonenum = document.querySelector('#calcLocation #custphone').value;
    var city = document.querySelector('#calcLocation #city').value;
    var postcode = document.querySelector('#calcLocation #postcode').value;
    var address = document.querySelector('#calcLocation #address').value;
    
    var state_e1 = document.querySelector('#calcLocation #states');
    var state = state_e1.value;

    if ( name == '' ||
      phonenum == '' ||
      state == ''
    ) {
      warningMsgLocation.classList.remove('hidden');
      warningMsgModel.classList.add('hidden');
      return;
    }

    var state_e2 = state_e1.options[state_e1.selectedIndex];
    var state_has_installation = state_e2.dataset.haveInstallation;
    var total_fee = state_has_installation == "true" ? state_e2.dataset.totalFee : state_e2.dataset.shippingFee;
    
    payload.name = name;
    payload.phonenum = phonenum;
    payload.state = state;
    payload.city = city;
    payload.postcode = postcode;
    payload.address = address;
    payload.has_installation = state_has_installation;
    payload.installation_shipping_fee = total_fee;
    
    toggleSec3();
    warningMsgLocation.classList.add('hidden');
    warningMsgModel.classList.add('hidden');
    lockcontent.classList.add('hidden');
    opencontent.classList.remove('hidden');

    last_section_active = true;
  }

  function liveChangeSection2() {
    if (last_section_active) {
      handleProceedSection2();
    }
  }

  function kitjson() {
    const el = document.getElementById("kitData");
    if (!el) return { kits: []};
    try { 
      return JSON.parse(el.textContent); 
    }
    catch { return { kits: []}; }
  }
  
  function calculateKitCategory(w, h) {
    // Get integer?
    w = Math.trunc(w);
    h = Math.trunc(h);

    let kitnum = null;
    let foundKit = null;
    let foundRange = null;

    for (const kit of kits) {
      let range = (kit.ranges || []).find(r => w >= +r.min && w <= +r.max);

      if (range) {
        kitnum = +kit.kit_no;
        foundKit = kit;
        foundRange = range;
        break;
      }
    }

    if (!foundKit && kits.length) {
      const lastKit = kits[kits.length - 1];
      const lastRange = lastKit?.ranges?.[lastKit.ranges.length - 1];

      if (lastRange && w > +lastRange.max) {
        foundKit = lastKit;
        foundRange = lastRange;
      }
    }

    if (!foundKit) return null;

    document.getElementById('calcKitCategory').textContent = foundKit.name;
    setKitMeasure(foundKit, foundRange);
    kitWTitle.dataset.totalW = `${w} cm`;
    kitHTitle.dataset.totalH = `${h} cm`;
    kitPreview.dataset.totalW = `Total Width ${w} cm`;
    kitPreview.dataset.totalH = `Total Height ${h} cm`;

    kitcategory = foundKit;
    return { kit: foundKit, range: foundRange }
  }
  
  function toggleSec2(kit, range) {
    var kitnum = kit.kit_no;
    var composition = range.composition.split('+').map(s => parseInt(s.trim(), 10)).filter(Number.isInteger);
    var composition_text = composition.map(s => `${s} cm`);
    var modelPreview = document.getElementById('calcModelType');

    composition_array = composition;
    
    // refresh the model type
    document.querySelectorAll('#calcModelType li.calc-preview-model').forEach((element, index) => {
      let model_width_preview = element.querySelector('.model-width-preview');
      model_width_preview.dataset.slotWidth = composition[index];
      model_width_preview.textContent = composition_text[index];

      if (convertNum(element.dataset.modelSlot) <= kitnum) {
        element.classList.remove('hidden');
        element.dataset.modelActive = true;
      } else {
        element.classList.add('hidden');
        element.dataset.modelActive = false;
      }

      if (convertNum(element.dataset.modelSlot) == 1) {
        element.classList.add('slot-active');
      } else {
        element.classList.remove('slot-active');
      }
      kitSelectbtn.value = 1;
    });

    // control slot-select option
    document.querySelectorAll('#slot-select option').forEach(element => {
      if (convertNum(element.value) <= kitnum || element.value == null) {
        element.classList.remove('hidden');
      } else {
        element.classList.add('hidden');
      }
    });

    // assign composition select
    document.querySelectorAll('#modelWidthTray .model-width-chip').forEach((element, index) => {
      if (convertNum(element.dataset.slot) <= kitnum) {
        element.classList.remove('hidden');
        
        element.dataset.slotWidth = composition[index];
        element.textContent = composition_text[index];
      } else {
        element.classList.add('hidden');

        element.dataset.slotWidth = 0;
        element.textContent = '';
      }
    })
  }

  function setKitMeasure(kit, range){
    range_composition = String(range.composition || "")
    .split("+")
    .map(s => parseInt(s.trim(), 10))
    .filter(n => Number.isFinite(n));
    let kitnum = kit.kit_no;
    let total_w = 0;
    for (const n of range_composition) total_w += n;
    let total_h = kit.height || "";

    kitCompTitle.dataset.kitComp = `Width = ${String(range.composition || "")} cm`;

    payload.kitwidth = total_w;
    payload.kitheight = total_h;
  }

  function setSelection(slot, model, element_name, value) {
    if (element_name && model == null) {
      model_selections[String(slot)][element_name] = value;
    } else {
      model_selections[String(slot)] = model;
    }
  }

  function toggleSec3 () {
    var kitnum = payload.kitnum;
    var model_array = []; // for model combination
    var model_price_array = []; // for price
    
    for (const [slot, model_info] of Object.entries(model_selections)) {
      if (slot <= kitnum) {
        model_array.push(model_info);
        model_price_array.push(convertNum(model_info.price));
      } else break;
    }

    document.getElementById('summaryKitCategory').textContent = kitcategory.name;
    document.getElementById('summaryKitPrice').textContent = `RM ${convertNumDisplay(kitcategory.price)}`;
    const n = Math.min(model_array.length, model_price_array.length);
    const elem = document.getElementById('summaryModelType');
    elem.textContent = '';

    for (let i = 0; i < n; i++) {
      const model_name = model_array[i].name;
      const model_width = model_array[i].width;
      const model_price = model_price_array[i];

      elem.insertAdjacentHTML('beforeend', `
        <div class="fs2 font-body-bold summary_model_type">
        ${model_name} (${model_width} cm)
        </div>
        <div class="fs2 right font-body-bold">RM ${convertNumDisplay(model_price.toFixed(2))}</div>
      `);
    }
    
    // Other Charges
    const other_elem = document.getElementById('summaryOthers');
    const state = payload.state;
    const additional_fees_name = payload.has_installation == 'true' ? 'Shipping & Installation' : 'Shipping Only';
    const additional_fees = payload.installation_shipping_fee;
    other_elem.textContent = '';
    other_elem.insertAdjacentHTML('beforeend', `
      <div class="fs2 font-body-bold">${additional_fees_name} (${state})</div>
      <div class="fs2 right font-body-bold">RM ${convertNumDisplay(additional_fees)}</div>
    `);
    
    const total_elem = document.getElementById('summaryTotal');
    const total = calculateTotal(model_price_array);
    total_elem.textContent = '';
    total_elem.insertAdjacentHTML('beforeend', `
      <div class="fs3 font-body-bold">Total</div>
      <div class="fs3 right font-body-bold">RM ${convertNumDisplay(total)}</div>
    `);

    payload.model = model_array;
    payload.total = total;
  }

  function calculateTotal(model_price_array) {
    var total = 0;
    total += convertNum(kitcategory.price);
    for (const price of model_price_array) {
      total += price;
    }
    total += convertNum(payload.installation_shipping_fee);
    return Number(String(total).replace(/,/g, '')).toFixed(2);
  }

  function getDeviceId() {
    const KEY = 'calc_device_id';
    let id = localStorage.getItem(KEY);
    if (!id) {
      id = (crypto?.randomUUID?.() || (Date.now() + '-' + Math.random())).replace(/\W/g, '');
      localStorage.setItem(KEY, id);
    }
    return id;
  }

  function convertNum(value) {
    const n = Number(String(value).replace(/,/g, ''));
    return Number.isFinite(n) ? n : 0;
  }

  function convertNumDisplay(value) {
    return Number(String(value).replace(/,/g, '')).toLocaleString('en-MY', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
  }

  function showLoading(){
    loadingEl.classList.remove('hidden');
    document.body.classList.add('calc-loading-open');
  }
  function hideLoading(){
    loadingEl.classList.add('hidden');
    document.body.classList.remove('calc-loading-open');
  }

  // Nested function in swapWidthChips
  function changePriceVariations(elem) {
    var width = elem.querySelector('.model-width-preview').dataset.slotWidth;
    if (elem.dataset.modelId == '') {
      return;
    }

    if (elem.dataset.modelPriceVariation != '[]') {
      var priceVariation = JSON.parse(elem.dataset.modelPriceVariation);
      const priceByWidth = Object.fromEntries(priceVariation.map(v => [Number(v.width), Number(v.price)]));
      var price = priceByWidth[width];
    } else {
      var price = elem.dataset.modelPrice;
    }
      
    elem.dataset.modelPrice = price;
    elem.querySelector('.model_price').textContent = `RM ${convertNumDisplay(price)}`;

    setSelection(elem.dataset.modelSlot, null, 'price', price);
    setSelection(elem.dataset.modelSlot, null, 'width', width);
  }

  function swapWidthChips(chipA, chipB) {
    // chipA and chipB are element
    if (!chipA || !chipB || chipA === chipB) return;
    const previewA = document.querySelector(`.calc-preview-model[data-model-slot="${chipA.dataset.slot}"] .model-width-preview`);
    const previewB = document.querySelector(`.calc-preview-model[data-model-slot="${chipB.dataset.slot}"] .model-width-preview`);
    const previewParentA = previewA.closest('li.calc-preview-model');
    const previewParentB = previewB.closest('li.calc-preview-model');

    const tmpText = chipA.textContent;
    chipA.textContent = chipB.textContent;
    previewA.textContent = chipB.textContent;
    chipB.textContent = tmpText;
    previewB.textContent = tmpText;

    const tmpW = chipA.dataset.slotWidth;
    chipA.dataset.slotWidth = chipB.dataset.slotWidth;
    previewA.dataset.slotWidth = chipB.dataset.slotWidth;
    chipB.dataset.slotWidth = tmpW;
    previewB.dataset.slotWidth = tmpW;

    // trigger animation (remove then re-add so it replays)
    [chipA, chipB].forEach(chip => {
      chip.classList.remove('swap-in');
      void chip.offsetWidth;
      chip.classList.add('swap-in');
      chip.addEventListener('animationend', () => chip.classList.remove('swap-in'), { once: true });
    });

    [previewA, previewB].forEach(preview => {
      preview.classList.remove('swap-in');
      void preview.offsetWidth;
      preview.classList.add('swap-in');
      preview.addEventListener('animationend', () => preview.classList.remove('swap-in'), { once: true });
    });

    changePriceVariations(previewParentA);
    changePriceVariations(previewParentB);
  }

  function resetSec() {
    // Reset shared variables
    model_selections = {};
    composition_array = [];
    selected_width_chip = [];

    // Reset payload
    payload.name = null;
    payload.phonenum = null;
    payload.state = null;
    payload.city = null;
    payload.postcode = null;
    payload.address = null;
    payload.has_installation = null;
    payload.installation_shipping_fee = null;
    payload.websiteb = null;
    payload.deviceId = null;
    payload.model = null;
    payload.total = null;

    // Reset element in section 2
    const no_model_img = document.querySelector('#calcModelType').dataset.noModelImg;
    document.querySelectorAll('.calc-preview-model').forEach(element => {
      element.dataset.modelActive = false;
      element.dataset.modelId = "";
      element.dataset.modelPrice = "";
      element.dataset.modelPriceVariation = "[]";

      element.querySelector('img').src = no_model_img;
      element.querySelector('.model-width-preview').dataset.slotWidth = "";
      element.querySelector('.model-width-preview').textContent = "";
      element.querySelector('.model_name').classList.add("visibility-hidden");
      element.querySelector('.model_name').textContent = "";
      element.querySelector('.model_price').classList.add("visibility-hidden");
      element.querySelector('.model_price').textContent = "";
    })

    // Reset last section
    var lockcontent_last = document.getElementById('calcSecLock3');
    var opencontent_last = document.getElementById('calcSec3');
    lockcontent_last.classList.remove('hidden');
    opencontent_last.classList.add('hidden');
    last_section_active = false;
  }


});
